import React from 'react';
import { useState } from 'react';
import useAccountAggregator from './AccountAggregatorHook';
import {
  Container,
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  alpha,
  useTheme,
  useMediaQuery,
  Avatar,
  Divider,
  Stack,
  Tooltip as MUITooltip,
  // IconButton,
} from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  AccountBalance,
  Receipt,
  PieChart as PieChartIcon,
  SwapHoriz,
  AccountBalanceWallet,
  Timeline,
  Person,
  LocalAtm,
  Bolt,
  // MoneyOff,
  TrendingFlat,
  // Flag,
  ArrowUpward,
  ArrowDownward,
  CreditCard,
  AttachMoney,
  // MoreVert,
  // Refresh,
  CalendarToday,
  Warning,
  Link as LinkIcon,
  Phone,
  Home,
  ShoppingCart
} from '@mui/icons-material';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import { Button } from '@mui/material';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';
import { Doughnut, Bar, Line } from 'react-chartjs-2';
import { Modal } from '@mui/material';
import { Backdrop } from '@mui/material';
import { Fade } from '@mui/material';
import { Close } from '@mui/icons-material';
import { FormControl } from '@mui/material';
// import PendingIcon from '@mui/icons-material/Pending';
import { RadioGroup, FormControlLabel, Radio, TextField, InputAdornment, MenuItem, Select } from '@mui/material';
import { toast } from 'react-toastify';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CircularProgress from '@mui/material/CircularProgress';
import { IconButton } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';


// Register ChartJS components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Filler
);

// Mock data from original HTML
// const analyticsData = {
//   overallAnalysis: {
//     totalAccounts: 2,
//     totalCreditAmount: 42453,
//     totalDebitAmount: 92917.64,
//     totalCreditTxn: 7,
//     totalDebitTxn: 23,
//     avgEodBalance: 1164682.38,
//     closingBalance: 1246658.94,
//     creditDebitRatio: 0.46,
//     velocity: 0.12,
//     surplusAmount: -50464.64,
//     totalExpenseAmount: 29550,
//     totalNoOfExpenseTransactions: 10,
//     avgExpenseAmount: 2955,
//     totalCashDepositAmount: 0,
//     totalCashWithdrawalsAmount: 0,
//     dailyAnalytics: [
//       { date: "2026-05-06", endOfDayBalance: 1272991.94 },
//       { date: "2026-05-07", endOfDayBalance: 1247658.94 },
//       { date: "2026-05-11", endOfDayBalance: 977231.58 },
//       { date: "2026-05-15", endOfDayBalance: 1246658.94 },
//       { date: "2026-05-19", endOfDayBalance: 946659.58 },
//       { date: "2026-05-26", endOfDayBalance: 1246658.94 }
//     ],
//     highValueCreditTxnsCount: 1,
//     highValueDebitTxnsCount: 5,
//     totalSalaryTxns: 0
//   },
//   accountWiseAnalysis: [
//     {
//       linkedAccRef: "b9de12ee-0b25-49e3-af26-4b9d96b5318e",
//       accountNumber: "XXXXXXXXXXXXXXXX4405",
//       bank: "Ignosis Bank Deposit 1",
//       totalCreditAmount: 0,
//       totalDebitAmount: 25333,
//       closingBalance: 946658.94,
//       currentBalance: "946658.91",
//       accountType: "DEFAULT",
//       totalCreditTxn: 0,
//       totalDebitTxn: 1
//     },
//     {
//       linkedAccRef: "58c95b85-f19d-4a3b-8120-8c29777d7ded",
//       accountNumber: "XXXXXXXXXXXXXXXX8860",
//       bank: "Ignosis Bank",
//       totalCreditAmount: 42453,
//       totalDebitAmount: 67584.64,
//       closingBalance: 300000,
//       currentBalance: "300000",
//       accountType: "SAVINGS",
//       totalCreditTxn: 7,
//       totalDebitTxn: 22
//     }
//   ],
//   allTransactions: [
//     { dateOfTransaction: "2026-05-07T04:06:01", narration: "MMT/IMPS/RAJESH SHAH", amount: 25333, type: "DEBIT", category: "Transfer out", bank: "Ignosis Bank Deposit 1" },
//     { dateOfTransaction: "2026-05-08T06:36:02", narration: "UPI mandardabir123", amount: 1000, type: "DEBIT", category: "Transfer out", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-08T06:36:02", narration: "UPI May 20", amount: 41737, type: "CREDIT", category: "Transfer in", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-09T06:36:02", narration: "Bill Payment Sarita dab", amount: 6500, type: "DEBIT", category: "Utilities", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-11T06:36:02", narration: "bharatpe.904174", amount: 2526, type: "DEBIT", category: "Merchant Expenditure", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-11T06:36:02", narration: "harshal.dhawale", amount: 20300, type: "DEBIT", category: "Transfer out", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-13T06:36:02", narration: "paytmqr", amount: 306, type: "DEBIT", category: "Merchant Expenditure", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-15T06:36:02", narration: "paytmqr small", amount: 85, type: "DEBIT", category: "Merchant Expenditure", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-18T06:36:02", narration: "pariharj89@okhd", amount: 13400, type: "DEBIT", category: "P2P Transfer", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-19T06:36:02", narration: "LIC OF INDIA", amount: 1493, type: "DEBIT", category: "Insurance Premium", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-20T06:36:02", narration: "SHADOWCR credit", amount: 410, type: "CREDIT", category: "Transfer in", bank: "Ignosis Bank" },
//     { dateOfTransaction: "2026-05-25T06:36:02", narration: "Coral Paywave fee", amount: 0.62, type: "DEBIT", category: "Bank Charges", bank: "Ignosis Bank" }
//   ],
//   completeCategoryWiseAnalysis: {
//     categoryWiseAnalysis: {
//       "Transfer out": { totalDebitAmount: 48474, totalDebitTxn: 9 },
//       "Utilities": { totalDebitAmount: 20738, totalDebitTxn: 3 },
//       "Merchant Expenditure": { totalDebitAmount: 8812, totalDebitTxn: 7 },
//       "P2P Transfer": { totalDebitAmount: 13400, totalDebitTxn: 1 },
//       "Insurance Premium": { totalDebitAmount: 1493, totalDebitTxn: 1 },
//       "Bank Charges": { totalDebitAmount: 0.64, totalDebitTxn: 2 },
//       "Transfer in": { totalCreditAmount: 42447, totalCreditTxn: 5 }
//     }
//   },
//   profileClassifications: [{ name: "UTILITY_USER" }, { name: "HEALTH_UNINSURED" }, { name: "UPI_USER" }]
// };

const AccountAggregator = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // eslint-disable-next-line
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const {  loan, InitiateConsent, setCustomNumber, customNumber, 
  setIsCustomMode, isCustomMode, refresh, handleCloseModal, verifyModalOpen, setVerifyModalOpen,
  underwritingstatus, monitoring, startMonitoring, analyticsData, FetchMonitoringJSON, CheckMonitoringStatus,
  fetchData, loading, monitoringJSONLoder, PullReports, copyToClipboard, banks, aaSelectedbank, setaaSelectedbank } = useAccountAggregator();
  const overall = analyticsData?.overallAnalysis;
  // eslint-disable-next-line 
  const categoryWise = analyticsData?.completeCategoryWiseAnalysis?.categoryWiseAnalysis || {};
  const transactions = analyticsData?.allTransactions || [];
  const accounts = analyticsData?.accountWiseAnalysis || [];
  const profileTags = analyticsData?.profileClassifications || [];
  // console.log("in comp-> ", analyticsData)
  const [transactionPage, setTransactionPage] = useState(0);
  const [transactionsPerPage] = useState(5);
  // eslint-disable-next-line 
  const handleTransactionPageChange = (event, newPage) => {
    setTransactionPage(newPage);
  };


  // Format currency helper
  const formatINR = (amount) => {
    if (amount === undefined || amount === null) return "₹0";
    return "₹" + Number(amount).toLocaleString('en-IN', { maximumFractionDigits: 0, minimumFractionDigits: 0 });
  };

  // Prepare category data for pie chart
  // Fix for category data - access the correct path
  // Based on your console output, the category data is in overallCategoryWiseAnalysis
  const categoryWiseData = analyticsData?.completeCategoryWiseAnalysis?.overallCategoryWiseAnalysis || {};

  const debitCategories = {};
  Object.entries(categoryWiseData).forEach(([cat, val]) => {
    // Check different possible value structures
    let debitAmount = 0;

    if (val && typeof val === 'object') {
      // Look for totalDebitAmount or debitAmount fields
      debitAmount = val.totalDebitAmount || val.debitAmount || 0;

      // If the value itself is the amount (some APIs return just the number)
      if (debitAmount === 0 && typeof val === 'number') {
        debitAmount = val;
      }
    } else if (typeof val === 'number') {
      debitAmount = val;
    }

    if (debitAmount > 0) {
      debitCategories[cat] = debitAmount;
    }
  });

  // Also check if there's a DEBIT category specifically
  // Some APIs split by transaction type
  const debitSpecificData = categoryWiseData?.DEBIT || {};
  if (Object.keys(debitSpecificData).length > 0) {
    Object.entries(debitSpecificData).forEach(([cat, val]) => {
      let amount = typeof val === 'object' ? (val.totalAmount || val.amount || 0) : val;
      if (amount > 0 && !debitCategories[cat]) {
        debitCategories[cat] = amount;
      }
    });
  }

  console.log("Category Wise Data:", categoryWiseData);
  console.log("Debit Categories:", debitCategories);

  const sortedDebit = Object?.entries(debitCategories)?.sort((a, b) => b[1] - a[1])?.slice(0, 6);
  const catLabels = sortedDebit?.map(i => i[0]) || [];
  const catData = sortedDebit?.map(i => i[1]) || [];

  const pieChartData = {
    labels: catLabels,
    datasets: [{
      data: catData,
      backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec489a'],
      borderWidth: 0,
    }]
  };

  // Bar chart data for credit/debit flow
  const barChartData = {
    labels: ['Credit', 'Debit'],
    datasets: [{
      label: 'Amount (₹)',
      data: [overall?.totalCreditAmount, overall?.totalDebitAmount],
      backgroundColor: ['#10b981', '#ef4444'],
      borderRadius: 8,
    }]
  };

  // Line chart data for balance trends
  const dailyData = overall?.dailyAnalytics || [];
  const lineChartData = {
    labels: dailyData?.map(d => new Date(d?.date)?.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })),
    datasets: [{
      label: 'End of Day Balance (₹)',
      data: dailyData?.map(d => d.endOfDayBalance),
      borderColor: '#3b82f6',
      backgroundColor: alpha('#3b82f6', 0.05),
      fill: true,
      tension: 0.3,
      pointBackgroundColor: '#2563eb',
      pointBorderColor: '#fff',
      pointBorderWidth: 2,
      pointRadius: 4,
      pointHoverRadius: 6,
    }]
  };

  const sortedTx = [...transactions]?.sort((a, b) => new Date(b.dateOfTransaction) - new Date(a?.dateOfTransaction));
  const paginatedTransactions = sortedTx?.slice(
    transactionPage * transactionsPerPage,
    transactionPage * transactionsPerPage + transactionsPerPage
  );
  const totalPages = Math.ceil((sortedTx?.length || 0) / transactionsPerPage);

  // New Financial Overview Cards Data
  // If you want 5 cards in a row (to match your image showing 5 metrics)
  const overviewCards = [
    {
      title: "AVERAGE MONTHLY BALANCE",
      value: formatINR(overall?.avgEodBalance || 0),
      subtitle: "Avg End of Day Balance",
      trend: overall?.creditDebitRatio ? `Ratio: ${overall?.creditDebitRatio}` : "N/A",
      trendDirection: "neutral",
      icon: <AccountBalance sx={{ color: '#10b981' }} />,
      gradient: 'linear-gradient(135deg, #10b98120 0%, #10b98110 100%)'
    },
    {
      title: "TOTAL CREDIT",
      value: formatINR(overall?.totalCreditAmount || 0),
      subtitle: `${overall?.totalCreditTxn || 0} transactions`,
      trend: "Inflow",
      trendDirection: "up",
      icon: <ArrowUpward sx={{ color: '#3b82f6' }} />,
      gradient: 'linear-gradient(135deg, #3b82f620 0%, #3b82f610 100%)'
    },
    {
      title: "TOTAL DEBIT",
      value: formatINR(overall?.totalDebitAmount || 0),
      subtitle: `${overall?.totalDebitTxn || 0} transactions`,
      trend: "Outflow",
      trendDirection: "down",
      icon: <ArrowDownward sx={{ color: '#ef4444' }} />,
      gradient: 'linear-gradient(135deg, #ef444420 0%, #ef444410 100%)'
    },
    {
      title: "NET FLOW",
      value: formatINR((overall?.totalCreditAmount || 0) - (overall?.totalDebitAmount || 0)),
      subtitle: "Total Surplus/Deficit",
      trend: ((overall?.totalCreditAmount || 0) > (overall?.totalDebitAmount || 0)) ? "Surplus" : "Deficit",
      trendDirection: ((overall?.totalCreditAmount || 0) > (overall?.totalDebitAmount || 0)) ? "up" : "down",
      icon: <TrendingUp sx={{ color: '#8b5cf6' }} />,
      gradient: 'linear-gradient(135deg, #8b5cf620 0%, #8b5cf610 100%)'
    },
    {
      title: "CLOSING BALANCE",
      value: formatINR(overall?.closingBalance || 0),
      subtitle: `Velocity: ${(overall?.velocity || 0).toFixed(2)}`,
      trend: `Surplus: ${formatINR(overall?.surplusAmount || 0)}`,
      trendDirection: (overall?.surplusAmount || 0) > 0 ? "up" : "down",
      icon: <AccountBalanceWallet sx={{ color: '#ec489a' }} />,
      gradient: 'linear-gradient(135deg, #ec489a20 0%, #ec489a10 100%)'
    }
  ];

  // Original KPI Cards data
  const kpiCards = [
    {
      title: "Total Credit",
      value: formatINR(overall?.totalCreditAmount),
      subtitle: `${overall?.totalCreditTxn || 0} transactions`,
      icon: <TrendingUp sx={{ color: '#10b981' }} />,
      bgColor: '#10b981'
    },
    {
      title: "Total Debit",
      value: formatINR(overall?.totalDebitAmount),
      subtitle: `${overall?.totalDebitTxn || 0} transactions`,
      icon: <TrendingDown sx={{ color: '#ef4444' }} />,
      bgColor: '#ef4444'
    },
    {
      title: "Avg EOD Balance",
      value: formatINR(overall?.avgEodBalance),
      subtitle: `Velocity ${(overall?.velocity || 0).toFixed(2)}`,
      icon: <Timeline sx={{ color: '#8b5cf6' }} />,
      bgColor: '#8b5cf6'
    },
    {
      title: "Closing Balance",
      value: formatINR(overall?.closingBalance),
      subtitle: `Surplus ${formatINR(overall?.surplusAmount)}`,
      icon: <AccountBalance sx={{ color: '#f59e0b' }} />,
      bgColor: '#f59e0b'
    },
    {
      title: "Monthly Expense",
      value: formatINR(overall?.totalExpenseAmount || 0),
      subtitle: `${overall?.totalNoOfExpenseTransactions || 0} expense transactions`,
      icon: <Receipt sx={{ color: '#ec489a' }} />,
      bgColor: '#ec489a'
    }
  ];

  // Chart options with responsive configurations
  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: isMobile ? 'bottom' : 'right',
        labels: { font: { size: isMobile ? 10 : 12 } }
      }
    }
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { callbacks: { label: (ctx) => `₹${ctx.raw.toLocaleString()}` } },
      legend: { position: 'top' }
    }
  };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { callbacks: { label: (ctx) => `₹${ctx.raw.toLocaleString()}` } },
      legend: { position: 'top' }
    }
  };

  return (
    <Box sx={{ bgcolor: '#f8fafc', overflowY: 'scroll', height: '80vh', py: { xs: 2, sm: 3, md: 4 } }}>
      <Container maxWidth="xl" sx={{ px: { xs: 1.5, sm: 2, md: 3 } }}>
        {/* Header Section */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: { xs: 3, sm: 4 },
          gap: 2
        }}>
          <Box>
            <Typography variant={isMobile ? "h5" : "h4"} sx={{
              fontWeight: 700,
              background: 'linear-gradient(135deg, #1e293b, #3b82f6)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              letterSpacing: '-0.3px',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
            }}>
              <Avatar sx={{ bgcolor: '#3b82f620', color: '#3b82f6', width: 40, height: 40 }}>

                {/* <CircularProgress/> */}
                {(loading || monitoringJSONLoder) ? <CircularProgress /> : <PieChartIcon />}
              </Avatar>
              Finance Analytics
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, mt: 1, ml: 1 }}>
              Account insights & transaction behaviour | Overall financial pulse
            </Typography>
          </Box>


          <IconButton onClick={() => {
            refresh()
            FetchMonitoringJSON()
            CheckMonitoringStatus()
            fetchData()
            toast.success("Data fetched successfully !");
          }} sx={{ '&:hover': { bgcolor: '#f1f5f9' } }}>

            <ReplayCircleFilledIcon fontSize='large' />
          </IconButton>

          {/* Mobile Verification & Link Section */}
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 2,
              p: 2,
              bgcolor: '#f8fafc',
              borderRadius: 4,
              border: '1px solid #e2e8f0'
            }}
          >
            {/* Bank Type Dropdown */}
            {/* <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 160, md: 180 } }}>
              <Select
                value={banktype}
                displayEmpty
                sx={{ borderRadius: 2 }}
                onChange={(e) => setbanktype(e.target.value)}
              >
                <MenuItem value="Select Bank">Select Bank</MenuItem>
                <MenuItem value="collection_bank">Collection Bank</MenuItem>
                <MenuItem value="disbursement_bank">Disbursement Bank</MenuItem>
              </Select>
            </FormControl> */}
            <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 160, md: 180 } }}>
              <Select
                value={aaSelectedbank}
                displayEmpty
                sx={{ borderRadius: 2 }}
                onChange={(e) => setaaSelectedbank(e.target.value)}
              >
                <MenuItem value="Select Bank">Select Bank</MenuItem>
                {
                  banks?.map((item) => <MenuItem value={item?.id}>{item?.name}</MenuItem>)
                }
              </Select>
            </FormControl>
            {/* Verify Mobile Button */}
            <MUITooltip title="Verify Mobile" arrow placement="top">
              <IconButton
                size="small"
                onClick={() => {
                  if (!aaSelectedbank) {
                    toast.error("Please select the bank type !")
                    return;
                  }
                  setVerifyModalOpen(true)
                }}
                sx={{
                  bgcolor: '#3b82f6',
                  color: 'white',
                  borderRadius: 2,
                  p: 1,
                  '&:hover': { bgcolor: '#2563eb' },
                  width: { xs: '100%', sm: 'auto' }
                }}
              >
                <Phone fontSize="small" />
              </IconButton>
            </MUITooltip>

            {/* Status Group */}
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1.5}
              
              sx={{
                flex: 1,
              
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              {/* Underwriting Status */}
              <Paper
                variant="outlined"
                sx={{
                  px: 1.5,
                  py: 0.75,
                  borderRadius: 2,
                  flex: 1,
                  bgcolor: underwritingstatus === 'Pending' ? '#fefce8' :
                  underwritingstatus === 'Completed' ? '#f0fdf4' : '#ffffff',
                  borderColor: underwritingstatus === 'Pending' ? '#fde047' :
                  underwritingstatus === 'Completed' ? '#bbf7d0' : '#e2e8f0',
                }}
              >
                <Stack
                  direction="row"
                  sx={{
                    width: '100%',
                    minWidth: { xs: '100%', sm: 'auto' }
                  }}
                  spacing={1.5}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: { xs: '0.75rem', sm: '0.813rem' }
                      }}
                    >
                      Underwriting:
                    </Typography>
                  </Stack>

                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      color: underwritingstatus === 'Pending' ? '#ca8a04' :
                        underwritingstatus === 'Completed' ? '#16a34a' :
                          underwritingstatus === 'Failed' ? '#dc2626' : '#64748b',
                      fontSize: { xs: '0.75rem', sm: '0.813rem' },
                      px: 1,
                      py: 0.25,
                      borderRadius: 1,
                      bgcolor: underwritingstatus === 'Pending' ? '#fefce8' :
                        underwritingstatus === 'Completed' ? '#f0fdf4' :
                          underwritingstatus === 'Failed' ? '#fef2f2' : 'transparent'
                    }}
                  >
                    {underwritingstatus || 'Not Started'}
                  </Typography>
                </Stack>
              </Paper>

              {/* Monitor Status */}
              <Paper
                variant="outlined"
                sx={{
                  px: 1.5,
                  py: 0.75,
                  borderRadius: 2,
                  flex: 1,
                  bgcolor: monitoring === 'ACTIVE' ? '#f0fdf4' :
                    monitoring === 'EXPIRED' ? '#fef2f2' : '#ffffff',
                  borderColor: monitoring === 'ACTIVE' ? '#bbf7d0' :
                    monitoring === 'EXPIRED' ? '#fecaca' : '#e2e8f0'
                }}
              >
                <Stack
                  direction="row"
                  spacing={1.5}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    width: '100%',
                    minWidth: { xs: '100%', sm: 'auto' }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#475569',
                      fontWeight: 600,
                      fontSize: { xs: '0.75rem', sm: '0.813rem' }
                    }}
                  >
                    Monitor:
                  </Typography>

                  <Typography
                    variant="body2"
                    fontWeight="bold"
                    sx={{
                      color: monitoring === 'ACTIVE' ? '#16a34a' :
                        monitoring === 'EXPIRED' ? '#dc2626' :
                          monitoring === 'PROCESSING' ? '#f59e0b' : '#64748b',
                      fontSize: { xs: '0.75rem', sm: '0.813rem' },
                      px: 1,
                      py: 0.25,
                      borderRadius: 1,
                      bgcolor: monitoring === 'ACTIVE' ? '#f0fdf4' :
                        monitoring === 'EXPIRED' ? '#fef2f2' :
                          monitoring === 'PROCESSING' ? '#fefce8' : 'transparent'
                    }}
                  >
                    {monitoring || 'Off'}
                  </Typography>
                </Stack>
              </Paper>
            </Stack>

            {/* Monitoring Control Button */}
            <MUITooltip title={"Monitoring"} arrow placement="top">
              <IconButton
                size="small"
                onClick={startMonitoring}
                sx={{
                  bgcolor: monitoring === 'ACTIVE' ? '#ef4444' : '#3b82f6',
                  color: 'white',
                  borderRadius: 2,
                  p: 1,
                  '&:hover': {
                    bgcolor: monitoring === 'ACTIVE' ? '#dc2626' : '#2563eb'
                  },
                  width: { xs: '100%', sm: 'auto' }
                }}
              >
                {(monitoring === "ACTIVE" || monitoring === "PROCESSING") ?
                  <PauseIcon fontSize="small" /> :
                  <PlayArrowIcon fontSize="small" />
                }
              </IconButton>
            </MUITooltip>

            {/* Date Range Group */}
            {/* <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1.5}
              sx={{
                alignItems: 'center',
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              <TextField
                required
                label="From"
                type="datetime-local"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                sx={{
                  width: { xs: '100%', sm: '12rem', md: '13rem' },
                  '& .MuiInputBase-root': { fontSize: '0.813rem' },
                  "& .MuiOutlinedInput-root": { borderRadius: 2 }
                }}
              />

              <Typography
                variant="body2"
                sx={{
                  color: '#94a3b8',
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                —
              </Typography>

              <TextField
                label="To"
                type="datetime-local"
                size="small"
                value={toDate}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setToDate(e.target.value)}
                sx={{
                  width: { xs: '100%', sm: '12rem', md: '13rem' },
                  '& .MuiInputBase-root': { fontSize: '0.813rem' },
                  "& .MuiOutlinedInput-root": { borderRadius: 2 }
                }}
              />
            </Stack> */}

            {/* Action Buttons Group */}
            <Stack
              direction={{ xs: 'row', sm: 'row' }}
              spacing={1}
              sx={{
                width: { xs: '100%', sm: 'auto' },
                justifyContent: 'flex-start'
              }}
            >
              <MUITooltip title="Pull Reports" arrow placement="top">
                <IconButton
                  size="small"
                  onClick={() => PullReports()}
                  sx={{
                    border: '1px solid #cbd5e1',
                    borderRadius: 2,
                    p: 1,
                    color: '#475569',
                    flex: { xs: 1, sm: 'none' },
                    '&:hover': {
                      borderColor: '#3b82f6',
                      color: '#3b82f6',
                      bgcolor: alpha('#3b82f6', 0.04)
                    }
                  }}
                >
                  <DescriptionIcon fontSize="small" />
                </IconButton>
              </MUITooltip>

              <MUITooltip title="Link Account" arrow placement="top">
                <IconButton
                  size="small"
                  onClick={() => {
                    let link = loan?.aa_link;
                    if (link) {
                      copyToClipboard(link)
                    } else {
                      toast.error("Link Not Found !")
                    }
                  }}
                  sx={{
                    border: '1px solid #cbd5e1',
                    borderRadius: 2,
                    p: 1,
                    color: '#475569',
                    flex: { xs: 1, sm: 'none' },
                    '&:hover': {
                      borderColor: '#3b82f6',
                      color: '#3b82f6',
                      bgcolor: alpha('#3b82f6', 0.04)
                    }
                  }}
                >
                  <LinkIcon fontSize="small" />
                </IconButton>
              </MUITooltip>
            </Stack>
          </Stack>
        </Box>


        {/* Financial Overview Cards - New Section */}
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccountBalanceWallet sx={{ fontSize: 22, color: '#3b82f6' }} /> Financial Overview
        </Typography>
        <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: 4 }}>
          {overviewCards.map((card, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <Card sx={{
                borderRadius: 4,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 20px 25px -12px rgba(0,0,0,0.1)' },
                border: '1px solid #e2e8f0',
                background: card.gradient,
                position: 'relative',
                overflow: 'hidden'
              }}>
                <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="caption" sx={{
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      color: '#64748b',
                      fontSize: '0.65rem'
                    }}>
                      {card.title}
                    </Typography>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                      {card.icon}
                    </Avatar>
                  </Box>

                  <Typography variant="h4" sx={{
                    fontWeight: 800,
                    color: '#0f172a',
                    fontFamily: 'monospace',
                    mb: 1,
                    fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' }
                  }}>
                    {card.value}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500 }}>
                      {card.subtitle}
                    </Typography>
                    <Chip
                      label={card.trend}
                      size="small"
                      icon={
                        card.trendDirection === 'up' ? <ArrowUpward sx={{ fontSize: 12 }} /> :
                          card.trendDirection === 'down' ? <ArrowDownward sx={{ fontSize: 12 }} /> :
                            <TrendingFlat sx={{ fontSize: 12 }} />
                      }
                      sx={{
                        bgcolor: card.trendDirection === 'up' ? alpha('#10b981', 0.1) :
                          card.trendDirection === 'down' ? alpha('#ef4444', 0.1) :
                            alpha('#f59e0b', 0.1),
                        color: card.trendDirection === 'up' ? '#10b981' :
                          card.trendDirection === 'down' ? '#ef4444' :
                            '#f59e0b',
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        height: 22,
                        '& .MuiChip-icon': { fontSize: 12, marginLeft: 0.5 },
                        '& .MuiChip-label': { px: 1 }
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        {/* // Add this section right after the Transaction Metrics Grid (around line 480-490) */}

        {/* Profile Tags Section */}
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1, mt: 4 }}>
          <Person sx={{ fontSize: 22, color: '#3b82f6' }} /> User Profile Tags
        </Typography>

        <Grid container spacing={{ xs: 1.5, sm: 2 }} sx={{ mb: 4 }}>
          {profileTags.map((tag, idx) => {
            // Get tag name (handle both string and object formats)
            const tagName = typeof tag === 'string' ? tag : tag?.name || tag?.tag || '';
            const formattedName = tagName.replace(/_/g, ' ');

            // Define colors based on tag categories
            const getTagColor = (name) => {
              const lowerName = name.toLowerCase();
              if (lowerName.includes('utility')) return { bg: '#3b82f620', color: '#3b82f6', icon: <Bolt sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('loan')) return { bg: '#ef444420', color: '#ef4444', icon: <AccountBalance sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('investor') || lowerName.includes('mutual') || lowerName.includes('traditional'))
                return { bg: '#10b98120', color: '#10b981', icon: <TrendingUp sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('health') || lowerName.includes('life') || lowerName.includes('uninsured'))
                return { bg: '#f59e0b20', color: '#f59e0b', icon: <Warning sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('food') || lowerName.includes('consumer'))
                return { bg: '#ec489a20', color: '#ec489a', icon: <LocalAtm sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('cab') || lowerName.includes('uber'))
                return { bg: '#8b5cf620', color: '#8b5cf6', icon: <Phone sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('tax'))
                return { bg: '#14b8a620', color: '#14b8a6', icon: <Receipt sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('credit card'))
                return { bg: '#6366f120', color: '#6366f1', icon: <CreditCard sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('rent'))
                return { bg: '#d946ef20', color: '#d946ef', icon: <Home sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('shopper') || lowerName.includes('online'))
                return { bg: '#f43f5e20', color: '#f43f5e', icon: <ShoppingCart sx={{ fontSize: 16 }} /> };
              if (lowerName.includes('upi'))
                return { bg: '#06b6d420', color: '#06b6d4', icon: <Phone sx={{ fontSize: 16 }} /> };
              return { bg: '#94a3b820', color: '#64748b', icon: <Person sx={{ fontSize: 16 }} /> };
            };

            const colors = getTagColor(tagName);

            return (
              <Grid item xs={6} sm={4} md={3} lg={2.4} key={idx}>
                <Card sx={{
                  borderRadius: 3,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: `0 8px 20px ${colors.color}20`,
                    borderColor: colors.color
                  },
                  border: `1px solid ${colors.color}30`,
                  bgcolor: colors.bg,
                  cursor: 'pointer',
                  height: '100%'
                }}>
                  <CardContent sx={{
                    p: { xs: 1.5, sm: 2 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                    <Avatar sx={{
                      width: 20,
                      height: 20,
                      bgcolor: `${colors.color}20`,
                      color: colors.color,
                      mb: 1.5
                    }}>
                      {colors.icon}
                    </Avatar>
                    <Typography variant="body2" sx={{
                      fontWeight: 700,
                      color: colors.color,
                      fontSize: '0.75rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      {formattedName}
                    </Typography>
                    {/* <Chip
                      label="Active"
                      size="small"
                      sx={{
                        mt: 1,
                        height: 20,
                        fontSize: '0.6rem',
                        bgcolor: `${colors.color}20`,
                        color: colors.color,
                        '& .MuiChip-label': { px: 1 }
                      }}
                    /> */}
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        {/* Transaction Metrics KPI Grid */}
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
          <TrendingUp sx={{ fontSize: 22, color: '#3b82f6' }} /> Transaction Metrics
        </Typography>
        <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} sx={{ mb: 4 }}>
          {kpiCards.map((kpi, idx) => (
            <Grid item xs={6} sm={4} md={2.4} key={idx}>
              <Card sx={{
                borderRadius: 3,
                transition: 'all 0.2s',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.08)' },
                border: '1px solid #e2e8f0',
                height: '100%'
              }}>
                <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.3px', color: '#64748b', fontSize: '0.6rem' }}>
                      {kpi.title}
                    </Typography>
                    <Avatar sx={{ width: 28, height: 28, bgcolor: alpha(kpi.bgColor, 0.1) }}>
                      {kpi.icon}
                    </Avatar>
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', fontFamily: 'monospace', mb: 0.5, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                    {kpi.value}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500, fontSize: '0.65rem' }}>
                    {kpi.subtitle}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Charts Row */}
        <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: 4 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', height: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                  <PieChartIcon sx={{ color: '#3b82f6' }} /> Spend by Category
                </Typography>
                <Chip label="Total Debits" size="small" variant="outlined" sx={{ borderColor: '#cbd5e1' }} />
              </Box>
              <Box sx={{ height: { xs: 240, sm: 280, md: 260 } }}>
                <Doughnut data={pieChartData} options={doughnutOptions} />
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', height: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                  <SwapHoriz sx={{ color: '#3b82f6' }} /> Credit / Debit Flow
                </Typography>
                <Chip label="Current Month" size="small" variant="outlined" sx={{ borderColor: '#cbd5e1' }} />
              </Box>
              <Box sx={{ height: { xs: 240, sm: 280, md: 260 } }}>
                <Bar data={barChartData} options={barOptions} />
              </Box>
            </Paper>
          </Grid>
        </Grid>

        {/* Top Categories & Recent Transactions */}
        <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: 4 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', height: '100%' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, mb: 2, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                <LocalAtm sx={{ color: '#3b82f6' }} /> Top Debit Categories
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Box>
                {sortedDebit.map(([category, amount], idx) => (
                  <Box key={category} sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    py: 1,
                    borderBottom: idx !== sortedDebit.length - 1 ? '1px solid #f1f5f9' : 'none'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar sx={{ width: 28, height: 28, bgcolor: alpha(['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec489a'][idx % 6], 0.1) }}>
                        <LocalAtm sx={{ fontSize: 14, color: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec489a'][idx % 6] }} />
                      </Avatar>
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#334155' }}>{category}</Typography>
                    </Box>
                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#0f172a' }}>{formatINR(amount)}</Typography>
                  </Box>
                ))}
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, mb: 2, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                <Receipt sx={{ color: '#3b82f6' }} /> Recent Transactions
                <Chip
                  label={`${sortedTx?.length || 0} total`}
                  size="small"
                  sx={{ ml: 'auto', bgcolor: '#f1f5f9' }}
                />
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <TableContainer sx={{ overflowX: 'auto', flex: 1 }}>
                <Table size="small" sx={{ minWidth: 500 }}>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f8fafc' }}>
                      <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem', py: 1.5 }}>Date</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem', py: 1.5 }}>Description</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem', py: 1.5 }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem', py: 1.5 }}>Type</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedTransactions.length > 0 ? (
                      paginatedTransactions.map((tx, idx) => (
                        <TableRow key={idx} sx={{ '&:hover': { bgcolor: '#f8fafc' } }}>
                          <TableCell sx={{ fontSize: '0.75rem', py: 1.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <CalendarToday sx={{ fontSize: 12, color: '#94a3b8' }} />
                              {new Date(tx.dateOfTransaction).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ maxWidth: 160, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.75rem', py: 1.5 }} title={tx.narration}>
                            {tx.narration?.substring(0, 25) || tx.description?.substring(0, 25) || '-'}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600, fontSize: '0.75rem', py: 1.5 }}>{formatINR(tx.amount)}</TableCell>
                          <TableCell sx={{ py: 1.5 }}>
                            <Chip
                              label={tx.type}
                              size="small"
                              sx={{
                                bgcolor: tx.type === 'CREDIT' ? alpha('#10b981', 0.1) : alpha('#ef4444', 0.1),
                                color: tx.type === 'CREDIT' ? '#10b981' : '#ef4444',
                                fontWeight: 700,
                                fontSize: '0.65rem',
                                height: 22
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" color="textSecondary">
                            No transactions found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  // flexDirection:'column',
                  flexWrap: 'wrap',
                  mt: 2,
                  pt: 2,
                  borderTop: '1px solid #e2e8f0'
                }}>
                  <Typography variant="caption" sx={{ color: '#64748b' }}>
                    Showing {transactionPage * transactionsPerPage + 1} to {Math.min((transactionPage + 1) * transactionsPerPage, sortedTx?.length || 0)} of {sortedTx?.length || 0} entries
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => setTransactionPage(prev => Math.max(0, prev - 1))}
                      disabled={transactionPage === 0}
                      sx={{
                        // minWidth: 'auto',
                        width: '10px',
                        height: '34px',
                        px: 1.5,
                        textTransform: 'none',
                        borderColor: '#cbd5e1',
                        '&:hover': { borderColor: '#3b82f6', bgcolor: alpha('#3b82f6', 0.04) }
                      }}
                    >
                      Previous
                    </Button>

                    {/* Page Numbers */}
                    <Box sx={{
                      display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center', overflow: 'hidden', height: '34px'
                    }}>
                      {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = i;
                        } else if (transactionPage < 3) {
                          pageNum = i;
                        } else if (transactionPage > totalPages - 3) {
                          pageNum = totalPages - 5 + i;
                        } else {
                          pageNum = transactionPage - 2 + i;
                        }

                        return (
                          <Button
                            key={pageNum}
                            size="small"
                            variant={transactionPage === pageNum ? "contained" : "outlined"}
                            onClick={() => setTransactionPage(pageNum)}
                            sx={{
                              minWidth: 32,
                              height: 32,

                              p: 0,
                              fontSize: '0.75rem',
                              fontWeight: transactionPage === pageNum ? 700 : 400,
                              bgcolor: transactionPage === pageNum ? '#3b82f6' : 'transparent',
                              borderColor: '#cbd5e1',
                              color: transactionPage === pageNum ? 'white' : '#64748b',
                              '&:hover': {
                                bgcolor: transactionPage === pageNum ? '#2563eb' : alpha('#3b82f6', 0.04),
                                borderColor: '#3b82f6'
                              }
                            }}
                          >
                            {pageNum + 1}
                          </Button>
                        );
                      })}
                    </Box>

                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => setTransactionPage(prev => Math.min(totalPages - 1, prev + 1))}
                      disabled={transactionPage === totalPages - 1}
                      sx={{
                        width: '10px',
                        height: '34px',
                        px: 1.5,
                        textTransform: 'none',
                        borderColor: '#cbd5e1',
                        '&:hover': { borderColor: '#3b82f6', bgcolor: alpha('#3b82f6', 0.04) }
                      }}
                    >
                      Next
                    </Button>
                  </Stack>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* Accounts Snapshot */}
        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, mb: 3, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            <AccountBalanceWallet sx={{ color: '#3b82f6' }} /> Accounts Snapshot
          </Typography>
          <Grid container spacing={2} sx={{ height: 'auto', overflowY: 'scroll' }}>
            {accounts.map((acc, idx) => (
              <Grid item xs={12} key={idx}>
                <Paper sx={{
                  p: { xs: 1.5, sm: 2 },
                  bgcolor: '#fafcff',
                  borderRadius: 3,
                  borderLeft: `4px solid #3b82f6`,
                  transition: 'all 0.2s',
                  '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }
                }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar sx={{ width: 32, height: 32, bgcolor: alpha('#3b82f6', 0.1) }}>
                        <AccountBalance sx={{ fontSize: 16, color: '#3b82f6' }} />
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#0f172a' }}>{acc?.bank}</Typography>
                        <Typography variant="caption" sx={{ color: '#64748b', fontFamily: 'monospace' }}>{acc?.accountNumber.slice(-12)}</Typography>
                      </Box>
                    </Box>
                    <Chip label={acc.accountType || 'DEPOSIT'} size="small" sx={{ bgcolor: alpha('#3b82f6', 0.1), color: '#3b82f6', fontWeight: 600 }} />
                  </Box>
                  <Divider sx={{ my: 1.5 }} />
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1.5, sm: 3 }} sx={{ flexWrap: 'wrap' }}>
                    <Box>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>Balance</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: '#0f172a' }}>{formatINR(acc?.closingBalance)}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>Credit Inflow</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#10b981' }}>+{formatINR(acc?.totalCreditAmount || 0)}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>Debit Outflow</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#ef4444' }}>-{formatINR(acc?.totalDebitAmount || 0)}</Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>Transactions</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>C:{acc?.totalCreditTxn || 0} | D:{acc?.totalDebitTxn || 0}</Typography>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* Balance Trends */}
        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', mb: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, mb: 2, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
            <Timeline sx={{ color: '#3b82f6' }} /> Monthly Balance Trends (EOD)
          </Typography>
          <Box sx={{ height: { xs: 240, sm: 280, md: 300 } }}>
            <Line data={lineChartData} options={lineOptions} />
          </Box>
        </Paper>

        {/* Additional Insights */}
        <Grid container spacing={{ xs: 2, sm: 3 }}>
          <Grid item xs={12}>
            <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, bgcolor: alpha('#3b82f6', 0.03), border: '1px solid #dbeafe' }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 3 }} sx={{ justifyContent: 'space-around', flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: alpha('#3b82f6', 0.1) }}>
                    <Timeline sx={{ fontSize: 16, color: '#3b82f6' }} />
                  </Avatar>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>Credit/Debit Ratio: <strong>{(overall?.creditDebitRatio || 0).toFixed(2)}</strong></Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: alpha('#f59e0b', 0.1) }}>
                    <Bolt sx={{ fontSize: 16, color: '#f59e0b' }} />
                  </Avatar>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>Monthly Velocity: <strong>{(overall?.velocity || 0).toFixed(2)}</strong></Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar sx={{ width: 32, height: 32, bgcolor: alpha('#10b981', 0.1) }}>
                    <AttachMoney sx={{ fontSize: 16, color: '#10b981' }} />
                  </Avatar>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>Avg Expense/Txn: <strong>{formatINR(overall?.avgExpenseAmount || 0)}</strong></Typography>
                </Box>
                {overall?.highValueDebitTxnsCount > 0 && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: alpha('#ef4444', 0.1) }}>
                      <Warning sx={{ fontSize: 16, color: '#ef4444' }} />
                    </Avatar>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#ef4444' }}>⚠️ High-value debits: <strong>{overall?.highValueDebitTxnsCount} transactions</strong></Typography>
                  </Box>
                )}
              </Stack>
            </Paper>
          </Grid>
        </Grid>

        {/* Footer */}
        <Box sx={{ textAlign: 'center', mt: 4, pt: 2, borderTop: '1px solid #e2e8f0' }}>
          <Typography variant="caption" sx={{ color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
            <PieChartIcon sx={{ fontSize: 12 }} /> Data based on account analytics | Overall credit/debit velocity & classifications
          </Typography>
        </Box>
      </Container>
      {/* Mobile Verification Modal - UI Only */}
      <Modal
        open={verifyModalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}
      >
        <Fade in={verifyModalOpen}>
          <Paper sx={{
            maxWidth: 480,
            width: '90%',
            borderRadius: 4,
            bgcolor: 'white',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Modal Header */}
            <Box sx={{
              p: 3,
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#3b82f6' }} />
                Select Mobile Number
              </Typography>
              <IconButton onClick={handleCloseModal} size="small">
                <Close />
              </IconButton>
            </Box>

            {/* Modal Content */}
            <Box sx={{ p: 3 }}>
              <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
                Select or enter phone number to initiate verification
              </Typography>

              <FormControl component="fieldset" sx={{ width: '100%' }}>
                <RadioGroup
                  value={isCustomMode ? 'custom' : 'existing'}
                  onChange={(e) => setIsCustomMode(e.target.value === 'custom')}
                >
                  {/* Existing Number Option */}
                  <Paper sx={{
                    mb: 2,
                    border: '1px solid #e2e8f0',
                    borderRadius: 2,
                    transition: 'all 0.2s',
                    '&:hover': { borderColor: '#3b82f6' }
                  }}>
                    <FormControlLabel
                      value="existing"
                      control={<Radio />}
                      label={
                        <Box sx={{ py: 1 }}>
                          <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a' }}>
                            EXISTING SYSTEM NUMBER
                          </Typography>
                          <Typography variant="body2" sx={{ fontFamily: 'monospace', color: '#3b82f6', mt: 0.5 }}>
                            {loan?.mobile || "Mobile Number is not found !"}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                            Primary Mobile
                          </Typography>
                        </Box>
                      }
                      sx={{ m: 0, width: '100%', p: 2 }}
                    />
                  </Paper>

                  {/* OR Divider */}
                  <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
                    <Divider sx={{ flex: 1 }} />
                    <Typography variant="caption" sx={{ px: 2, color: '#94a3b8', fontWeight: 600 }}>OR</Typography>
                    <Divider sx={{ flex: 1 }} />
                  </Box>

                  {/* Custom Number Option */}
                  <Paper sx={{
                    border: isCustomMode ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                    borderRadius: 2,
                    transition: 'all 0.2s'
                  }}>
                    <FormControlLabel
                      value="custom"
                      control={<Radio />}
                      label={
                        <Box sx={{ py: 1, width: '100%' }}>
                          <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a' }}>
                            ENTER CUSTOM NUMBER
                          </Typography>
                          <TextField
                            type='number'
                            fullWidth
                            placeholder="Enter mobile number"
                            value={customNumber}
                            onChange={(e) => setCustomNumber(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            disabled={!isCustomMode}
                            size="small"
                            sx={{ mt: 1.5 }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Phone sx={{ fontSize: 18, color: '#94a3b8' }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                      }
                      sx={{ m: 0, width: '100%', p: 2, alignItems: 'flex-start' }}
                    />
                  </Paper>
                </RadioGroup>
              </FormControl>

              {/* Action Buttons */}
              <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={{ textTransform: 'none', fontWeight: 600 }}
                >
                  Cancel
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: '#3b82f6',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': { bgcolor: '#2563eb' }
                  }}
                  onClick={InitiateConsent}
                >
                  Initiate
                </Button>
              </Box>
            </Box>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AccountAggregator;